import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../getProcedureInformation/actions';
import { Types as TypesCancel } from './cancelUseCase/actions';
import ProcedureRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../core/config/config';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const { request } = action;
    yield put({ type: Types.REGISTER_CARNET_REQUEST });
    XCheckpointManager.registerStart('Emisión de carné universitario register');
    const registerCarnetRepository: ProcedureRepository =
      new ProceduresDataRepository();
    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    const registerCarnetResponse = yield call(
      registerCarnetRepository.registerCarnet,
      request
    );
    if (!registerCarnetResponse) {
      yield put({
        type: Types.REGISTER_CARNET_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    if (registerCarnetResponse?.error) {
      yield put({
        type: Types.REGISTER_CARNET_FAILURE,
        requestId: registerCarnetResponse?.requestId,
        error:
          registerCarnetResponse?.error ||
          'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
      });
      return;
    }

    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });
    yield put({
      type: TypesCancel.CANCEL_REGISTER_CARNET_CLEAR
    });
    yield put({
      type: Types.REGISTER_CARNET_SUCCESS,
      requestId: registerCarnetResponse?.registerCarnet?.requestId
    });
    XCheckpointManager.registerEnd('Emisión de carné universitario register');
  } catch (error) {
    yield put({
      type: Types.REGISTER_CARNET_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
